<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

import { NewProduct, NewProductModification } from '@/types/api/api-v4/product'
import { ProductType } from '@/types/components/product-card.types'

type Props = {
  product: NewProduct
  productType: ProductType
  currentModification: NewProductModification
  productsQuantity: number
}

const props = defineProps<Props>()

const emit = defineEmits(['on-add', 'on-increase', 'on-decrease'])

const { currencySymbol } = useCityStore()

const isActive = computed(() => {
  return props.productsQuantity > 0 && props.productType === ProductType.simple
})
</script>

<template>
  <div class="product-card-footer">
    <the-card-button
      :price="currentModification.price"
      :old-price="currentModification.subprice"
      :currency="currencySymbol"
      :is-active="isActive"
      :type="productType"
      @on-add="emit('on-add')"
      @on-increase="emit('on-increase')"
      @on-decrease="emit('on-decrease')"
    />
  </div>
</template>

<style lang="scss" scoped>
.product-card-footer {
  padding: 0 8px 8px;

  @include media('>=desktop-mini') {
    padding: 0 16px 16px;
  }
}
</style>
